
export const LocaleEN = {

}
